import { ChangeDetectorRef, Injectable } from '@angular/core';
import { HttpInterceptorService } from '../../core/services/http-interceptor.service';
import { Observable } from 'rxjs/Observable';
import { HttpResponse } from '@angular/common/http';


const UPLOAD_URL = 'form/upload';

@Injectable()
export class FileUploadService {

  constructor(private http: HttpInterceptorService) {
  }

  /**
   *
   * @param {File} file
   * @param {string} storageName
   * @param processorType
   * @param {boolean} toggleLoader
   * @returns {Subscription}
   */
  uploadFormData<T = any>(file: File, storageName: string, options: UploadFormDataOptions = { }, toggleLoader: boolean = false): Observable<HttpResponse<T>> {
    const defaultValues: UploadFormDataOptions = {
      processorType: undefined,
      noFriendlyName: 'false',
      checksumAlgorithm: undefined,

    };
    const data = Object.assign(defaultValues, options);
    const fd = this.getFormData(file);
    return this.http.post(UPLOAD_URL, fd, toggleLoader, { }, {
      'processor': this.getParamValue(data.processorType),
      'storageName': this.getParamValue(storageName),
      'noFriendlyName': data.noFriendlyName,
      'checksumAlgorithm': data.checksumAlgorithm,
      'processorOptions': data.fileProcessorOptions ? JSON.stringify(data.fileProcessorOptions) : '{}'
    });
  }

  getFormData(file: File) {
    const fd = new FormData();
    fd.append('file', file);
    return fd;
  }
  getParamValue(paramVal: string) {
    return paramVal === undefined ? '' : paramVal;
  }
}

export interface UploadFormDataOptions {
  processorType?: string;
  noFriendlyName?: string;
  checksumAlgorithm?: string;
  fileProcessorOptions?: FileProcessorOptions;
}

export interface FileProcessorOptions {
  acceptedFileExtensions?: Array<string>;
  acceptedPublishers?: Array<string>;
  additionalWarnings?: Array<string>;
}
